import { api } from './api';
import {
  GrupoFechamento,
  CreateGrupoFechamentoDTO,
  ListGrupoFechamentosDTO,
  ListGrupoFechamentosResponse,
  IGrupoFechamentoPreviewDTO,
  GrupoFechamentoEstatisticas
} from '../types/grupos';

export interface FechamentosService {
  listar(params: ListGrupoFechamentosDTO): Promise<ListGrupoFechamentosResponse>;
  criar(data: CreateGrupoFechamentoDTO): Promise<GrupoFechamento>;
  buscarPorId(id: string): Promise<GrupoFechamento>;
  gerarPreview(params: GrupoFechamentoEstatisticas): Promise<IGrupoFechamentoPreviewDTO>;
  criarFechamento(data: CreateGrupoFechamentoDTO): Promise<GrupoFechamento>;
  listarFechamentos(params: ListGrupoFechamentosDTO): Promise<ListGrupoFechamentosResponse>;
  obterFechamento(id: string): Promise<GrupoFechamento>;
  excluirFechamento(id: string): Promise<void>;
  finalizarFechamento(id: string): Promise<GrupoFechamento>;
}

class FechamentosServiceImpl implements FechamentosService {
  // Alias para manter compatibilidade
  async listar(params: ListGrupoFechamentosDTO): Promise<ListGrupoFechamentosResponse> {
    return this.listarFechamentos(params);
  }

  async criar(data: CreateGrupoFechamentoDTO): Promise<GrupoFechamento> {
    return this.criarFechamento(data);
  }

  async buscarPorId(id: string): Promise<GrupoFechamento> {
    return this.obterFechamento(id);
  }

  async criarFechamento(data: CreateGrupoFechamentoDTO): Promise<GrupoFechamento> {
    const response = await api.post('/grupos/fechamentos', {
      ...data,
      data_inicio: data.data_inicio.toISOString(),
      data_fim: data.data_fim.toISOString()
    });
    return response.data;
  }

  async listarFechamentos(params: ListGrupoFechamentosDTO): Promise<ListGrupoFechamentosResponse> {
    const { id_grupo, ...queryParams } = params;
    const response = await api.get(`/grupos/${id_grupo}/fechamentos`, {
      params: queryParams
    });
    return response.data;
  }

  async obterFechamento(id: string): Promise<GrupoFechamento> {
    const response = await api.get(`/grupos/fechamentos/${id}`);
    return response.data;
  }

  async gerarPreview(params: GrupoFechamentoEstatisticas): Promise<IGrupoFechamentoPreviewDTO> {
    const response = await api.get('/grupos/fechamentos/preview', { params });
    return response.data;
  }

  async excluirFechamento(id: string): Promise<void> {
    await api.delete(`/grupos/fechamentos/${id}`);
  }

  async finalizarFechamento(id: string): Promise<GrupoFechamento> {
    const response = await api.patch(`/grupos/fechamentos/${id}/finalizar`);
    return response.data;
  }
}

export const fechamentosService = new FechamentosServiceImpl();
